<template>
    <div class="pt-7">
      
  </div>
</template>

<script>
import { contractorPortal } from '@/config/contractorPortal'

let apiEndpoint = process.env.VUE_APP_API_BASEURL

export default {
  name: 'Logout',
  components: {
  },
  data() {
    return {
      uploads: [],
    };
  },
  methods: {
    logoutUser() {
        // Remove localstorage
        localStorage.removeItem('contractorToken')
        localStorage.removeItem('contractorName')
        sessionStorage.removeItem('contractorReadyStatus')
        sessionStorage.removeItem('contractorReadyStatusAt')

        this.$store.commit('setContractorLoggedIn', false)
        this.$store.commit('setContractorName', '')

        // Redirect to login
        const requestedReturn = typeof this.$route.query.return_to === 'string'
          ? this.$route.query.return_to
          : null
        const safeReturn = this.validPortalReturn(requestedReturn)

        if (safeReturn) {
          window.location.replace(safeReturn)
        } else if (contractorPortal.enabled) {
          window.location.replace(this.$route.query.from_portal === '1'
            ? contractorPortal.loginUrl
            : contractorPortal.logoutUrl)
        } else {
          this.$router.push('/contractor/login')
        }
    },
    validPortalReturn(value) {
      if (!value || !contractorPortal.enabled) return null

      try {
        const requested = new URL(value)
        const allowedOrigins = [contractorPortal.loginUrl, contractorPortal.dashboardUrl]
          .filter(Boolean)
          .map(url => new URL(url).origin)

        return allowedOrigins.includes(requested.origin)
          ? requested.href
          : null
      } catch (error) {
        return null
      }
    },
  },
  created() {
    this.logoutUser();
  },
}
</script>
